<template>
  <div id="outside-box">
    <h3 class="center">Außenbereich &amp; Garten</h3>
    <br>
    <div class="grid grid-24">
      <img class="justify-center col-0 above-sm-col-span-8 below-md-fill img-frame" src="@/assets/media/outside/head.jpeg"/>
      <div class="align-center col-0 above-sm-col-9 fill">
        <p>Bei der Auswahl der Materialen im Außenbereich setzen wir auf nachhaltige und langlebige Harthölzer wie Robinie, sibirische Lärche, Kebony und FSC zertifizierte Exoten- Hölzer, sowie WPC-Dielen. Diese verarbeiten wir zu Gartenzäunen, Toren, Carports, Terrassen und Sitzbereichen.</p>
    <p>Zusätzlich installieren wir Rollläden, individuelle Sicht-, Sonnen- und Wetterschutzelemente sowie Fassadenverblendungen aus verschiedenen Materialien, wie HPL, Vollkern Kompakt Platten und diverse Kunststoffe.</p>
      </div>
    </div>
    <br>
    <br>

    <h3 class="center">Galerie</h3>
    <br>
    <image-gallery :images="galleryImages"/>
  </div>
</template>

<script>
export default {
  name: "Outside",
  data() {
    return {
      galleryImages:this.importImages()
    };
  },
  methods:{
    importImages(){
      function importAll(r) { return r.keys().sort().map(r); }
      var images = importAll(require.context('@/assets/media/outside', false, /img\d+\.(png|jpe?g|svg)$/));
      return images.map(i=>{return {src:i}})
    }
  }
};
</script>

<style>

</style>
